export const encodeRfc5987ValueChars = (str: string): string => {
  return encodeURIComponent(str)
    .replace(/['()]/g, (c) => `%${c.charCodeAt(0).toString(16)}`)
    .replace(/\*/g, '%2A')
    .replace(/%(?:7C|60|5E)/g, (_str, hex) =>
      String.fromCharCode(Number.parseInt(hex, 16)),
    );
};
